// Theme-aware react-select styles built on the app's CSS variables, so menus,
// options, chips and placeholders follow light/dark mode. Pass a component's
// own style functions as `overrides` (they receive the themed styles).
const themed = {
  control: (base) => ({
    ...base,
    backgroundColor: "var(--input-bg)",
    color: "var(--input-text)",
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--surface)",
    border: "1px solid var(--stroke-alt)",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
    zIndex: 20,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "var(--primary)"
      : state.isFocused
      ? "var(--primary-tint)"
      : "transparent",
    color: state.isSelected ? "var(--on-primary)" : "var(--input-text)",
    ":active": { backgroundColor: "var(--primary-tint)" },
  }),
  singleValue: (base) => ({ ...base, color: "var(--input-text)" }),
  input: (base) => ({ ...base, color: "var(--input-text)" }),
  placeholder: (base) => ({ ...base, color: "var(--input-placeholder)" }),
  multiValue: (base) => ({ ...base, backgroundColor: "var(--primary-tint)" }),
  multiValueLabel: (base) => ({ ...base, color: "var(--input-text)" }),
  multiValueRemove: (base) => ({
    ...base,
    color: "var(--input-text)",
    ":hover": { backgroundColor: "var(--status-missed-bg)", color: "var(--status-missed-text)" },
  }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: "var(--stroke-alt)" }),
  dropdownIndicator: (base) => ({ ...base, color: "var(--gray)" }),
  clearIndicator: (base) => ({ ...base, color: "var(--gray)" }),
  noOptionsMessage: (base) => ({ ...base, color: "var(--gray)" }),
};

export const themedSelectStyles = (overrides = {}) => {
  const keys = new Set([...Object.keys(themed), ...Object.keys(overrides)]);
  return Object.fromEntries(
    [...keys].map((key) => [
      key,
      (base, state) => {
        const withTheme = themed[key] ? themed[key](base, state) : base;
        return overrides[key] ? overrides[key](withTheme, state) : withTheme;
      },
    ])
  );
};
